
  <!-- Author: lss@ies. Html doc and Css style locked. -->
  <!-- このドキュメントを個人的に変更することは固く禁じられています。一度変更すると、サポートは提供しません。 -->

<template>
  <main-layout>

    <!-- 左メニュー -->
    <div slot="left-side">
      <menubar screenIdParam="M-06-02" />
    </div>
    <!--  左メニュー終了  -->

    <!-- ヘッダー行 -->
    <el-row slot="header">
      <headTitle class="cancel-width">
        <label slot="title">{{$t('title.system.owner.title')}}</label>
        <narrow-down
          v-auth="{ auth: '010202'}"
          @click="createOwner"
          slot="create">
          {{$t('button.system.owner.search.add')}}
        </narrow-down>
        <!-- <narrow-down
          v-auth="{ auth: '010202'}"
          @click="doCreateDummyData"
          slot="cancel">
          {{$t('button.system.owner.search.dummyCreate')}}
        </narrow-down> -->
      </headTitle>
    </el-row>

    <!-- メインページ -->
    <div slot="body">

      <!-- 検索パネル -->
      <div class="panel-search">
        <el-form
          ref="query"
          :model="query"
          :rules="rules"
          class="search-form">

          <!-- オーナーID-->
          <div class="fm-row">
            <el-form-item prop="ownerExId">
              <el-input
                maxlength="20"
                class="fm-input"
                v-model="query.ownerExId"
                :placeholder="$t('label.system.owner.search.ownerExidPlaceholder')">
              </el-input>
            </el-form-item>
            <el-form-item prop="ownerName">
              <el-input
                maxlength="50"
                class="fm-input"
                v-model="query.ownerName"
                :placeholder="$t('label.system.owner.search.ownerNamePlaceholder')">
              </el-input>
            </el-form-item>
          </div>
          <div class="fm-row btn-area">
            <div class="form-group">
              <narrow-down @click="searchOwner(query)">
                {{$t('button.system.owner.search.search')}}
              </narrow-down>
              <cancel-narrow-down class="link-primary margin-left-8" @click="clearSearchParams">
                {{$t('button.system.building.search.clear')}}
              </cancel-narrow-down>
            </div>
          </div>
        </el-form>
      </div>
      <!--   検索エリア終了   -->
      <div>
        <label v-show="isShow" class="list-title">{{$t('label.system.owner.search.ownerList')}}</label>
        <el-row v-show="isShow">
          <div class="text-right">
            <label class="label-right lable-right-16">{{ $t("label.common.count") }}</label>
            <el-select
              @change="changePageSize"
              v-model="query.pageSize"
              class="zdyselect">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </el-row>
      </div>

      <!--   検索結果表示開始   -->
      <div ref="searchResultTable" id="search-result" class="margin-top-28 with-100">
        <!-- @on-setup-function="setupFunction"
          @on-import-machine="importMachine"
          @on-export-machine="exportMachine" -->
        <owner-search-result-beautify
          :result="searchResult.content"
          :isShow="this.isShow"
          @on-delete="deleteOwner"
          @on-detail="detailOwner"
          @on-edit="editOwner"/>
      </div>
      <!--   検索結果表示終了   -->
      <!--   ページネーション   -->
      <pagination
        v-show="pagingShow"
        class="pagination-top"
        :totalCount="searchResult.totalCount"
        :totalPage="searchResult.totalPage"
        :pageSize="query.pageSize"
        :pageNumber="searchResult.pageNumber"
        @on-paging="handlePagingAction" />
    </div>
    <!--  ページ本文終了  -->

  </main-layout>
</template>

<script>
import SystemManageApi from "@/api/SystemManageApi"
import OwnerSearchResultBeautify from "@/components/system/OwnerSearchResultBeautify"
import OwnerSearchRuleFactory from "@/rules/rule-owner-search"
import cancelNarrowDown from "@/components/common/generalButton/CancelNarrowDown"
import narrowDown from "@/components/common/generalButton/NarrowDown"
import headTitle from "@/components/common/head/head"
import Pagination from "@/components/common/pagination/Pagination"
import NewDesignLayout from "@/layout/NewDesignLayout"
import Menubar from "@/components/leftmenu/DashBoard"
import errorCodeMsg from "@/utils/error-code-msg"
import statusErrorCodeMsg from "@/utils/status-error-msg"

const DEFAULT_PAGE_SIZE = 10
const DEFAULT_PAGE_NUMBER = 1
export default {
  name: "OwnerSearch",
  components: {
    MainLayout: NewDesignLayout,
    OwnerSearchResultBeautify: OwnerSearchResultBeautify,
    cancelNarrowDown,
    narrowDown,
    headTitle,
    Menubar,
    Pagination,
  },
  data() {
    return {
      createSuccess: this.$t("message.common.createSuccess",{
        field: "ダミーデータ"
      }),
      rules: OwnerSearchRuleFactory.searchRules(this),
      isShow: false,
      status:null,
      ownerId:null,
      message:null,
      // ページの検索条件
      query: {
        ownerName: null,
        ownerExId: null,
        ownerId: null,
        pageSize: DEFAULT_PAGE_SIZE,
        pageNumber: DEFAULT_PAGE_NUMBER,
        totalPage: 0,
        totalCount: 0
      },
      // 検索結果
      searchResult: {
        pageSize: DEFAULT_PAGE_SIZE,
        pageNumber: DEFAULT_PAGE_NUMBER,
        totalPage: 0,
        totalCount: 0,
        content: [
          {
            ownerId:null,
            ownerExId:null,
            ownerName:null,
            deleteFlag:null,
            buildings:[
              {
                id:null,
                exId:null,
                name:null
              }
            ]
          }
        ]
      },
      options: [
        {
          label: "10件",
          value: 10,
        },
        {
          label: "20件",
          value: 20,
        },
        {
          label: "50件",
          value: 50,
        },
      ],
      isSearching: false,
      tableLoadingAnim: null,
      showSelectOwnerDialog: false,
    }
  },
  methods: {
    changNumber(value){
      this.query.pageSize = value
    },
    /**
     * テーブル読み込みアニメーションを表示する
     */
    showTableLoadingAnim() {
      if (this.tableLoadingAnim == null) {
        this.tableLoadingAnim = this.$loading({
          target: "#search-result",
          background: "#ebebe6"
        })
      }
    },
    //オーナーサブ画面の選択
    selectOwner: function() {
      this.showSelectOwnerDialog = true
    },

    /**
     * テーブル読み込みアニメーションを非表示
     */
    hideTableLoadingAnim() {
      if (this.tableLoadingAnim != null) {
        this.tableLoadingAnim.close()
        this.tableLoadingAnim = null
      }
    },

    /**
     * ページングイベントの処理
     */
    handlePagingAction(pagination) {
      this.query.pageSize = pagination.pageSize
      this.query.pageNumber = pagination.pageNumber
      this.doneSearchOwner()
      this.$refs.searchResultTable.scrollIntoView()
    },

    searchOwner() {
      this.$saveQueryParam("owner_search_id", this.query)
      this.$refs['query'].validate((valid) => {
        if (valid) {
          this.doneSearchOwner()
          this.isShow = true
        }
      });
    },

    doCreateDummyData() {
      this.showLoading = true;
      SystemManageApi.createDummyData({})
      .catch((error) => {
        errorCodeMsg(error, this)
      })
      .then(({ data }) => {
          if (!statusErrorCodeMsg(data.statusCode, this)) {
            return;
          }
          this.$messageIotSuccess(this.createSuccess);
        }).finally(()=>{
          this.showLoading = false
        })
    },
    /**
     * オーナー情報检索
     */
    doneSearchOwner() {
      if (!this.isSearching) {
        this.isSearching = true
        this.showTableLoadingAnim()
        this.searchResult.content = []
        SystemManageApi.searchOwnerWithBuilding({
          ownerName: this.query.ownerName,
          ownerExId: this.query.ownerExId,
          pageSize: this.query.pageSize,
          pageNumber: this.query.pageNumber,
          ownerId : this.query.ownerId
        })
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({data}) => {

          if(!statusErrorCodeMsg(data.statusCode, this)) {
            return;
          }

          this.searchResult.pageNumber = data.body.pageNumber
          this.searchResult.totalPage = data.body.totalPage
          this.searchResult.totalCount = data.body.totalCount
          this.searchResult.pageSize = data.body.pageSize
          for (let body of data.body.body) {
          this.searchResult.content.push({
            ownerId: body.id,
            ownerExId: body.exId,
            ownerName: body.name,
            buildings: body.buildingList,
            deleteFlag: body.deleteFlag
          })
        }

        }).finally(() => {
          this.isSearching = false
          this.hideTableLoadingAnim()
        })
      }
    },

    /**
     * オーナー情報照会
     * @param ownerId
     */
    detailOwner(ownerId) {
      this.$saveQueryParam("owner_search_id", this.query)
      this.$router.push({
        name: 'system-owner-detail',
        params: {
          ownerId: ownerId
        }
      })
    },
    handlerOwnerSelected: function (owner) {
      this.query.ownerId = owner.id
      this.query.ownerName = owner.name
      this.query.ownerExId = owner.exId
    },
    createOwner(){
      this.$saveQueryParam("owner_search_id", this.query)
      this.$router.push({
        name: 'system-owner-create'
      })
    },

    /**
     * オーナー情報編集
     * @param ownerId
     */
    editOwner(ownerId) {
      this.$saveQueryParam("owner_search_id", this.query)
      this.$router.push({
        name: 'system-owner-edit',
        params: {
          ownerId: ownerId
        }
      })
    },

    /**
     * オーナー情報削除
     * @param ownerId
     */
    deleteOwner(ownerId) {
      this.showTableLoadingAnim()
      SystemManageApi.deleteOwner(ownerId)
      .catch((error) => {
        errorCodeMsg(error, this)
      })
      .then(({data}) => {
        if(!statusErrorCodeMsg(data.statusCode, this)) {
          return;
        }
        let index = -1, owners = this.searchResult.content
        for (let i = 0; i < owners.length; i++) {
          if (owners[i].id === ownerId) {
            index = i
            break
          }
        }
        owners.splice(index, 1)
      }).finally(() => {
        this.hideTableLoadingAnim()
        this.searchOwner()
        this.$messageIotSuccess(this.$t("message.common.delete",{
          field: this.$t("label.system.owner.detail.owners")
        }));
      })
    },

    /**
     * オーナー機能設定
     * @param ownerId
     */
    // setupFunction(ownerId) {
    //   // TODO
    //   alert(ownerId)
    // },

    // /**
    //  * 販売マシン導入
    //  * @param ownerId
    //  */
    // importMachine(ownerId) {
    //   // TODO
    //   alert(ownerId)
    // },

    changePageSize(){
      this.query.pageNumber = 1
      this.searchOwner()
    },

    /**
     * 販売マシン出力
     * @param ownerId
     */
    // exportMachine(ownerId) {
    //   // TODO
    //   alert(ownerId)
    // },
        //クリア
    clearSearchParams: function () {
      this.$saveQueryParam("owner_search_id", null)
      this.query.ownerExId = null
      this.query.ownerName = null
      this.query.buildingEXId = null
      this.query.buildingName = null
      this.query.totalPage = 0
      this.query.totalCount = 0
      this.searchResult.content = []
      this.isShow = false
      this.query.pageSize = DEFAULT_PAGE_SIZE
      this.query.pageNumber = DEFAULT_PAGE_NUMBER
    }
  },
  watch: {
    query: {
      handler() {
        this.query.pageNumber = 1
      },
      deep: true
    }
  },
  mounted () {
    this.query.totalCount = 0
    let queryObj = this.$getQueryParam("owner_search_id")
    if(queryObj!=null){
      this.query = queryObj
      this.doneSearchOwner()
      this.isShow = true
    }
  },
  computed: {
    pagingShow() {
      return this.searchResult.content.length > 0;
    }
  },
  created () {
    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: "label.router.comprehensive",
      },
      {
        path: "",
        title: "label.router.owner",
      }
    ]
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb);
    this.searchResult.content=[]
    this.$authCheck("010201")
  }

}
</script>

<style lang="scss" scoped>
::v-deep .cancel-width{
  .my-button{
    width: 188px;
    height: 32px;
  }
}
.must-top{
  color:#525250;
  padding-top: 55px;
}

.button-align{
  vertical-align: middle;
}
.margin-left-20{
  margin-left: 20px;
}

.text-padding-right {
  padding-right: 20px;
}
.float-right{
  float: right;
}
.float-left{
  float: left;
}
.button-margin{
  margin-top: 4px;
}

::v-deep .zdyselect {
  width: 120px;
  font-size: 15px;
  height: 40px;
  border-radius: 15px;
  box-shadow: -2px -2px 4px #fff,
              4px 4px 4px #E6E6E1;
  .el-input__inner {
    height: 40px;
    border-radius: 10px;
    background-color: #F2F2ED;
    border: 0;
    color: #525250;
  }
  .el-input__suffix {
    top: 0px;
  }
  .el-input__icon {
    line-height: 25px !important;
  }
}
::v-deep .zdyInput {
  .el-input__inner {
    height: 26px;
    border-radius: 0px !important;
    color: #525250;
    border: 2px solid;
    border-color: #bce0fd;
    font-size: 12px;
  }
  .el-input__inner::placeholder {
    color: #bce0fd;
  }
  /* 谷歌 */
  .el-input__inner::-webkit-input-placeholder {
    color: #bce0fd;
  }
}
//.page-col-left{
//  margin-left: 80%;
//}
.label-right{
  position: relative;
  right: 10px;
  font-size: 16px;
}
::v-deep .sp-table-cell{
  color: #6B6B69;
  font-weight: 100;
  font-size: 1px !important;
}
::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td{
  background: #F2F2ED;
}
.pagination-top{
  position: relative;
  top: 30px;
}



::v-deep .el-input__suffix {
  top: 0px;
}
::v-deep .el-input__icon {
  line-height: 25px !important;
}
::v-deep .el-form-item__content{
  margin-left: 0em !important;
}
.col-botton-left{
  position: relative;
  left: 100px;
}
.el-col-let{
  position: relative;
  top: 10px;
  left: 60px;
}
.page-font-size{
  font-size: 12px !important;
}
.title-botton-left{
  position: relative;
  left: 510px;
}
::v-deep .new-input-style {
  line-height: 0px;
  margin: 0px;
  padding: 0;
.el-input__inner{
width: 324px;
height: 44px !important;
border-radius: 8px !important;
background: #F2F2ED;
border: none;
box-shadow: -2px -2px 5px #ffffff inset, -2px -2px 5px #ffffff inset,
4px 5px 5px #E6E6E1 inset, 4px 5px 5px #E6E6E1 inset;
}
}
.float-left {
  float: left;
}
</style>
